import { useMemo } from "react"
import useAuth from "./useAuth"

function useAuthorization(required, validators?: any, any?: any) {
  const {
    permissions,
    user: { isSuperadmin },
  } = useAuth()
  const isAuthorized = useMemo(
    () =>
      isSuperadmin
        ? true
        : required && any
        ? required.some(rp => permissions.find(p => p.match(rp)))
        : required && !any
        ? required.every(rp => permissions.find(p => p.match(rp)))
        : true,
    [permissions, any, isSuperadmin, required]
  )

  const isValid = useMemo(
    () => (validators ? validators.every(v => v) : true),
    [validators]
  )
  const renderComponent = isSuperadmin ? true : isAuthorized && isValid

  return renderComponent
}

useAuthorization.defaultProps = {
  validators: [],
  required: [],
  any: false,
}

export default useAuthorization
